export default {
    install (app) {
        app.config.globalProperties.$utils = {
            lodash: _,
            idAttrs: (id,makeUnique=false) => ({ id: makeUnique ? _.uniqueId(id) : id, automation_id: id })
        };
    }
};
